import { inject, Injectable } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { LocaleString } from "../translate/localeString.model";

@Injectable({
    providedIn: 'root'
})
export class LocalizeService {

    private translate = inject(TranslocoService);

    transform(value: LocaleString | string): string {
        if (!value) {
            return '';
        }

        const lang = this.translate.getActiveLang();
        const defaultLang = this.translate.getDefaultLang();

        if (Array.isArray(value)) {
            const langString = value.find((v: { locale: string; text: string }) => v.locale === lang);
            if (langString) {
                return langString.text;
            } else {
                return '';
            }
        } else if (typeof value === 'string') {
            return value;
        } else {
            return value[lang] ?? value[defaultLang] ?? value[Object.keys(value)[0]] ?? '';
        }
    }
}